/**
 * 自テナント処分業者
 * ドロップダウン展開用
 */
import Vue from "vue";
import * as httpConst from "../../../../../../constants/httpConst";

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/members/tenant_disposer_locations`;

const search_members_tenant_disposer = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    // /**
    //  * 自テナント処分業者一覧(絞り込み条件付き)
    //  * @param commit
    //  * @param { Object } conditions 検索条件
    //  * @param { String } conditions.query ルート名
    //  * @param { Number } conditions.target_id 対象ID
    //  * @param { Number } conditions.location_id 事業場ID
    //  * @param { Number } page ページ番号
    //  * @return {Promise<unknown>}
    //  */
    // index({ commit }, { conditions, page }) {
    //   const params = {
    //     ...conditions,
    //     page: page,
    //   };
    //   return new Promise((resolve) => {
    //     Vue.$http.get(API_PATH, { params: params }).then((data) => {
    //       resolve(data.content);
    //     });
    //   });
    // },
    /**
     * 事業者・事業場詳細
     * @param commit
     * @param id
     * @param trader_id
     * @return {Promise<unknown>}
     */
    show({ commit }, { id, trader_id }) {
      const params = { trader_id: trader_id };
      return new Promise((resolve) => {
        Vue.$http.get( `${API_PATH}/${id}`, { params: params } ).then((data) => {
          let content = data.content;
          resolve(content);
        });
      });
    },
  },
  mutations: {},
};
export default search_members_tenant_disposer;
